/* eslint-disable */
import type { LocalizedString } from "../../../localization/localization.pb";
import type { Icon } from "../../Icon.pb";

/**
 * ⚠️ This is not owned or maintained by the Arcade team.
 * Please refer to the official Arcade design system for supported and maintained components.
 *
 * The `list-unordered` element.
 */
export interface ListUnordered {
  /** The list items to be displayed. */
  items?: ListUnorderedListItem[];
  /**
   * The variant to be used for the list ordered element.
   * If not provided, `STANDARD` will be used.
   */
  variant?: ListUnorderedVariant;
}

export enum ListUnorderedVariant {
  CLIENT_COULD_NOT_PARSE_LIST_ORDERED_VARIANT = "CLIENT_COULD_NOT_PARSE_LIST_ORDERED_VARIANT",
  STANDARD = "STANDARD",
  SUBTLE = "SUBTLE",
}

export enum ListUnorderedSize {
  CLIENT_COULD_NOT_PARSE_LIST_UNORDERED_SIZE = "CLIENT_COULD_NOT_PARSE_LIST_UNORDERED_SIZE",
  COMPACT = "COMPACT",
  LARGE = "LARGE",
}

export interface ListUnorderedListItem {
  /**
   * The icon to be displayed on the left.
   * If not provided, the icon will not be displayed.
   */
  icon?: Icon;
  /** Required. The label to be displayed in the left column. */
  label?: LocalizedString;
  /**
   * The value to be displayed in the right column.
   * If not provided, the value will not be displayed (1 column layout).
   */
  value?: LocalizedString;
  /**
   * The list body to be displayed below the label.
   * If not provided, the body will not be displayed.
   */
  body?: LocalizedString;
}
